import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const NoDataIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 23 28" htmlColor="#A6A9AB" {...props}>
            <path d="M14.1615 0.666698H3.49479C2.02812 0.666698 0.828125 1.8667 0.828125 3.33337V24.6667C0.828125 26.1334 2.01479 27.3334 3.48146 27.3334H19.4948C20.9615 27.3334 22.1615 26.1334 22.1615 24.6667V8.6667L14.1615 0.666698ZM19.4948 24.6667H3.49479V3.33337H12.8281V10H19.4948V24.6667Z" />
            <path d="M16.2088 15.1716L14.3232 13.286L11.4948 16.1144L8.66636 13.286L6.78075 15.1716L9.60917 18L6.78075 20.8285L8.66636 22.7141L11.4948 19.8856L14.3232 22.7141L16.2088 20.8285L13.3804 18L16.2088 15.1716Z" />
        </SvgIcon>
    );
};
